import React, {useEffect, useRef, useState} from "react";
import './music.css';
import {useDispatch} from "react-redux";
import {createWorkoutSetupData} from "../../store/slices/workoutSetup";

const MusicPlayer = ({tracks}) => {
  const localWorkoutSetupData = JSON.parse(localStorage.getItem('workoutSetupData'));
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [volume, setVolume] = useState(0.5);
  const [isPlaying, setIsPlaying] = useState(
    localWorkoutSetupData ? localWorkoutSetupData.music === 'yes' : false);
  const audioRef = useRef(null);
  const inputRangeRef = useRef(null);
  const dispatch = useDispatch();

  const handleTogglePlay = () => {
    if (audioRef.current.paused) {
      setVolume(0.5);
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  }

  useEffect(() => {
    if (isPlaying) {
      dispatch(createWorkoutSetupData({...localWorkoutSetupData, music: 'yes'}));
    } else {
      dispatch(createWorkoutSetupData({...localWorkoutSetupData, music: 'no'}));
    }
  }, [isPlaying]);

  const updateRangeBackground = (percentage) => {
    return `linear-gradient(to right, #6F525C ${percentage}%, #E5DDFF ${percentage}%)`;
  };

  const handleChangeVolume = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    audioRef.current.volume = newVolume;
  }

  useEffect(() => {
    if (volume === 0) {
      setIsPlaying(false);
      audioRef.current.pause();
      audioRef.current.volume = 0;
    } else {
      audioRef.current.volume = volume;
    }
  }, [volume]);

  const handleNextTrack = () => {
    setCurrentTrackIndex(prev => (prev + 1) % tracks.length);
  }

  useEffect(() => {
    setCurrentTrackIndex(Math.floor(Math.random() * tracks.length));
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      const onCanPlayThrough = () => {
        if (isPlaying) {
          audioRef.current.play();
        }
        audioRef.current.removeEventListener('canplaythrough', onCanPlayThrough);
      };

      audioRef.current.addEventListener('canplaythrough', onCanPlayThrough);
    }
  }, [currentTrackIndex, isPlaying]);

  useEffect(() => {
    if (inputRangeRef.current) {
      inputRangeRef.current.addEventListener('touchstart', () => {
        inputRangeRef.current.classList.add('active');
      })

      inputRangeRef.current.addEventListener('mousedown', () => {
        inputRangeRef.current.classList.add('active');
      })

      inputRangeRef.current.addEventListener('touchend', () => {
        inputRangeRef.current.classList.remove('active');
      })

      inputRangeRef.current.addEventListener('mouseup', () => {
        inputRangeRef.current.classList.remove('active');
      })
    }
  }, [inputRangeRef]);

  return (
    <div className='workout-navigation__music-start'>
      <audio ref={audioRef}
             src={tracks[currentTrackIndex]}
             onEnded={handleNextTrack}
        // autoPlay
      />
      <img
        className=''
        onClick={handleTogglePlay}
        loading="lazy"
        src={isPlaying ? require("./img-music/icon-music-on.svg").default
          : require("./img-music/icon-music-off.svg").default}
        width='24'
        height='24'
        alt="icon music">
      </img>
      <input ref={inputRangeRef}
             className={`volume-range ${isPlaying ? 'volume-range--visible' : ''}`}
             type="range"
             min='0'
             max='1'
             step='0.01'
             value={volume}
             onChange={handleChangeVolume}
             aria-label="Volume control"
             role="slider"
             aria-valuemin="0"
             aria-valuemax="1"
             aria-valuenow={volume}
             style={{
               background: updateRangeBackground(volume * 100),
             }}/>
    </div>
  )
}

export default MusicPlayer;